import { AxiosError } from "axios";
import { Text } from '@fluentui/react';

export const getFormattedErrorMessage = (error: AxiosError) => {
        if(error.response) {
            if(error.response.data) {
                if((error.response.data as any).errors) {
                    const errors: string[] = [];
                    for (const property in (error.response.data as any).errors) {
                        errors.push((error.response.data as any).errors[property]);
                    }
                    return errors.map((e: string) => <Text block>{e}</Text>);
                } else if((error.response.data as any).title) {
                    return (
                        <Text block>{(error.response.data as any).status}: {(error.response.data as any).title}</Text>
                    );
                } else {
                    return (JSON.stringify(error.response.data));
                }
            } else {
                return error.message;
            }
        } else {
            return error.message;
        }
}